export default {
    smartSearch: {
        errorsTipNum: '{num} エラー',
        errorCode: {
            10001: '不明なフィールドコード',
            10002: '検索フィールドをネストすることはできません。該フィールド名はテキストとして識別されます。',
            10003: 'このコマンドは、ANS/ANCS/ALL_ANフィールドのみ使用できます',
            10004: '文法間違い',
            20001: '最初の演算子が無効です',
            20002: '重複演算子',
            20003: '無効な最後の演算子',
            20004: '論理演算子の数が1024を超えているため',
            30001: '値がありません',
            30002: 'オペレータが見つかりません：)',
            30003: '余分な演算子：)',
            30004: 'オペレータが見つかりません：]',
            30005: '余分な演算子：]',
            30006: 'オペレータが見つかりません："',
            30007: "オペレータが見つかりません：'",
            30008: 'オペレータが見つかりません：|',
            40001: '位置コネクタ形式エラー',
            40002: '出現頻度演算子形式エラー',
            40003: '位置演算子の数が15を超えているため',
            40004: 'N値の上限は50です',
            40005: '文法間違い',
            50001: '数値のみ',
            50002: '不正な日付形式（YYYY or YYYYMM or YYYYMMDD）',
            50003: '開始日より前の終了日',
            50004: 'このフィールドには正の整数しか入力できません',
            50005: '終了番号は開始番号よりも小さい',
            60001: '検索フォーマットエラー',
            70001: '特殊な検索式形式エラー',
            70002: '1つの検索式は、1つの特別な検索式のみを含むことができます。',
            70003: '特殊な検索式の位置は検索式の先頭のみとします。',
            70004: 'フォルダパスを|| 内に設定してください',
            70005: '選択メニューと階層メニューのタグ値を""に入れてください',
            70006: 'not blankを""に入れてください',
            80001: 'RコマンドはANDを使用してのみ接続できます',
            80002: '検索ステートメントに表示できるRコマンドは1つだけです',
            80003: 'R命令の位置は検索式の先頭のみです。',
        },
        nodata: 'データなし',
    },
};
